import apiClient from "../common";

/** Nombre de archivo sugerido leído del header Content-Disposition. */
function filenameFromDisposition(
  disposition: string | undefined,
  fallback: string,
): string {
  if (!disposition) return fallback;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (utf8?.[1]) return decodeURIComponent(utf8[1]);
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain?.[1]?.trim() || fallback;
}

/**
 * GET /api/v1/supply-documents/{id}/pdf/
 * Descarga el PDF de la Orden de Compra y dispara la descarga en el navegador.
 */
export async function apiDownloadPurchaseOrderPdf(
  supplyDocumentId: string,
  documentNumber?: string,
): Promise<void> {
  const res = await apiClient.get(`supply-documents/${supplyDocumentId}/pdf/`, {
    withCredentials: true,
    responseType: "blob",
  });

  const fallback = `PO ${documentNumber ?? supplyDocumentId}.pdf`;
  const filename = filenameFromDisposition(
    res.headers?.["content-disposition"] as string | undefined,
    fallback,
  );

  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
